import React, { useState } from "react";
import axios from "axios";

function EndbannerHomeItemDetalle(props) {
  const endbannerHome = props.endbannerHome

  const [inputFile, setInputFile] = useState('')
  const [urlInput, setUrlInput] = useState('')

  let idElementoNum = endbannerHome.idElement.split('-')[2]
  let urlString = endbannerHome.description + ''

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('home-endbanner-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-endbanner-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeURL = (event) => {
    setUrlInput(event.target.value)
    document.getElementById('ribbon-endbanner-' + idElementoNum).classList.remove('d-none')
  }

  const onSubmit = () => {
    const data = new FormData()

    for (let i = 0; i < inputFile.length; i++) {
      data.append('file[]', inputFile[i])
    }

    data.append('name', endbannerHome.idElement)
    data.append('url', document.getElementById('url-endbanner-' + idElementoNum).value)

    const API_URL = process.env.REACT_APP_API_URL

    axios.post(API_URL + '/new-endbanner-home', data, {}).then(
      (res) => {
        console.log(res)
        document.getElementById('ribbon-endbanner-' + idElementoNum).classList.add('d-none')
      },
      (error) => {
        alert(error)
      }
    )
  }

  return (
    <div className='col-lg-4 mb-8 endbannerHomeItem' key={endbannerHome.idElement}>
      <div className='card card-custom overlay overflow-hidden'>
        <div className='card-body p-0 ribbon'>
          <div id={'ribbon-endbanner-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={endbannerHome.url}
              alt=''
              className={'w-100 rounded img-carousel home-endbanner-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-endbanner-' + idElementoNum}
                name={'file-endbanner-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeImage(event)}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() => document.getElementById('file-endbanner-' + idElementoNum).click()}
              />
            </div>
          </div>
        </div>
      </div>
      <label className='form-label mt-6'>URL</label>
      <input
        id={'url-endbanner-' + idElementoNum}
        name={'url-endbanner-' + idElementoNum}
        className='form-control'
        type='text'
        defaultValue={urlString}
        onChange={(e) => onChangeURL(e)}
      />
      <div className='mt-4 float-end'>
        <button className='btn btn-primary btn-sm' onClick={() => onSubmit()}>
          Guardar
        </button>
        <button
          className='btn btn-danger btn-sm ms-2'
          onClick={() => props.deleteEndbannerHome(props.endbannerHome.idElement)}
        >
          Eliminar
        </button>
      </div>
    </div>
  )
}

export {EndbannerHomeItemDetalle}